import React from 'react';
import {Text as RNText} from 'react-native';
import {defaultTheme, styles} from '../../theme';
import {CustomTextProps} from './Text.type';
import {font as fontStyles} from 'src/theme/Font';

const CustomText = (props: CustomTextProps) => {
  const {
    font = '500',
    size = 13,
    mt,
    ml,
    mb,
    mr,
    txtAlign,
    lh,
    style,
    color,
    children,
    ...rest
  } = props;
  return (
    <RNText
      {...rest}
      style={{
        fontFamily: fontStyles?.[font] || fontStyles['400'],
        color: color || defaultTheme.colors.grey8_5,
        marginTop: mt,
        marginBottom: mb,
        marginLeft: ml,
        marginRight: mr,
        fontSize: size || 14,
        textAlign: txtAlign || 'right',
        lineHeight: lh,
        ...style,
      }}>
      {props.children}
    </RNText>
  );
};
export {CustomText};
